import { IDigitalSign } from "domain/contracts/digital-sign.contracts";
import { DigitalSign } from "domain/entities/digital-sign";
import { DigitalSignInputFilter } from "domain/models/digital-sign-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";

class DigitalSignRepository implements IDigitalSign {
  // async delete(id: string): Promise<Message<boolean>> {
  //   const response = await httpClient.delete(`/digitalSign/${id}`);
  //   return response.data;
  // }

  async create(input: DigitalSign): Promise<Message<DigitalSign>> {
    const response = await httpClient.post(`/digitalSign`, { data: input });
    return response.data;
  }

  async update(input: DigitalSign): Promise<Message<boolean>> {
    const response = await httpClient.put(`/digitalSign/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getAll(
    filter: DigitalSignInputFilter
  ): Promise<Message<DigitalSign[]>> {
    const response = await httpClient.get(`/digitalSign`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<DigitalSign>> {
    const response = await httpClient.get(`/digitalSign/${id}`);
    return response.data;
  }
}

export default new DigitalSignRepository();
